import {mapActions} from "vuex";

export default {
    props:['orderId'],
    data(){
        return{
            receipts: [],
            loading: true,
        }
    },
    created() {
        this.loadReceipts().then(() => {});
    },
    methods:{
        receiptTypeLabel(type) {
            const normalized = String(type).toLowerCase();
            if (normalized === 'sale' || normalized === 'sell') {
                return this.$t('popupReceipts.type_sale');
            }
            if (normalized === 'refund' || normalized === 'return') {
                return this.$t('popupReceipts.type_refund');
            }
            return this.$t('popupReceipts.type_unknown');
        },
        receiptTypeClass(type) {
            const normalized = String(type).toLowerCase();
            if (normalized === 'sale' || normalized === 'sell') {
                return 'badge-success';
            }
            if (normalized === 'refund' || normalized === 'return') {
                return 'badge-danger';
            }
            return 'badge-secondary';
        },
        receiptStatusLabel(status) {
            if (!status) {
                return this.$t('popupReceipts.st_created');
            }
            const normalized = String(status).toLowerCase();
            const statusMap = {
                created: this.$t('popupReceipts.st_created'),
                pending: this.$t('popupReceipts.st_pending'),
                processing: this.$t('popupReceipts.st_processing'),
                done: this.$t('popupReceipts.st_done'),
                completed: this.$t('popupReceipts.st_done'),
                success: this.$t('popupReceipts.st_success'),
                error: this.$t('popupReceipts.st_error'),
                failed: this.$t('popupReceipts.st_error'),
                canceled: this.$t('popupReceipts.st_canceled'),
                cancelled: this.$t('popupReceipts.st_canceled'),
            };
            return statusMap[normalized] || status;
        },
        async loadReceipts(){
            this.loading = true;
            const res = await this.getReceiptsByOrder(this.orderId);
            if (res.status) {
                this.receipts = res.data || [];
            } else {
                this.receipts = [];
            }
            this.loading = false;
        },
        closePopup(){
            this.$emit('closePopup');
        },
        ...mapActions({
            getReceiptsByOrder:'checkbox/getReceiptsByOrder',
        })
    },
    destroyed() {
        this.receipts = [];
    }
}
